import { datadogRum } from '@datadog/browser-rum'
import { isConsentForPerformanceGranted, userConsentPerformances } from './consent'
import { waitFor } from './waitFor'

export const initDatadog = async () => {
  const environment = import.meta.env.VITE_ENV

  // Sans outil de consentement (ex. local), on n'initialise pas Datadog
  const consent = await userConsentPerformances().catch(() => undefined)
  if (consent === undefined) return

  // Init Datadog RUM
  datadogRum.init({
    applicationId: 'bb92a0fe-7ad7-474e-ad5c-cea3c77047b6',
    clientToken: 'pubf9d23089e7b2c4dab65a4508c9689646',
    remoteConfiguration: { id: '3055b996-ab66-4cc9-bf30-ef4502b83e72' },
    site: 'datadoghq.eu',
    service: 'infinity-front',
    env: getEnvDatadog(environment),
    version: import.meta.env.VITE_VERSION,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask',
    allowedTracingUrls: [`${import.meta.env.VITE_API_URL}`],
    trackingConsent: consent ? 'granted' : 'not-granted',
  })

  // Update tracking consent status
  const cactReady = await waitFor(
    () => !!globalThis.window.tC && typeof globalThis.window.cact === 'function',
  ).then(
    () => true,
    () => false,
  )
  if (!cactReady) return

  globalThis.window.cact('consent.onUpdate', function (result) {
    const consentPerformanceGranted = isConsentForPerformanceGranted(result)
    datadogRum.setTrackingConsent(consentPerformanceGranted ? 'granted' : 'not-granted')
  })
}

export const getEnvDatadog = (env: string) => {
  switch (env) {
    case 'production':
      return 'prd'
    case 'integration':
      return 'int'
    case 'recette':
      return 'rct'
    default:
      return 'dev'
  }
}
